import classNames from "classnames";
import { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import ButtonSmily from "@Components/atoms/ButtonSmily";
import Link from "@Components/atoms/Link";
import { ReactComponent as IconChevron } from "@Icons/16x16/chevron-down.svg";
import { MondialRelayLocation } from "@Types/addresses";
import { Day } from "@Types/api/time";
import "./style.scss";

interface Props {
  location: MondialRelayLocation;
  onSelectLocation: (location: MondialRelayLocation) => void;
}

const CheckoutPickupLocationItem: FunctionComponent<Props> = ({ location, onSelectLocation }) => {
  const intl = useIntl();
  const [displayOpeningHours, setDisplayOpeningHours] = useState<boolean>(false);

  const days: Day[] = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];
  const distance =
    parseFloat(location.distance) / 1000 <= 1
      ? {
          unit: "m",
          value: location.distance,
        }
      : {
          unit: "km",
          value: (parseFloat(location.distance) / 1000).toFixed(1),
        };

  const handleClick = () => setDisplayOpeningHours(!displayOpeningHours);

  return (
    <div className="CheckoutPickupLocationItem">
      <div className="CheckoutPickupLocationItem-content">
        <div className="CheckoutPickupLocationItem-content-name">
          <span className="CheckoutPickupLocationItem-content-company">{location.company}</span>
          <span className="CheckoutPickupLocationItem-content-distance">
            {intl.formatMessage(
              { id: "cheerz_CheckoutPickupLocationItem_distance" },
              { unit: distance.unit, value: distance.value }
            )}
          </span>
        </div>
        <div className="CheckoutPickupLocationItem-content-address">
          {location.street}, {location.postcode} {location.city}
        </div>
        <div
          className={classNames("CheckoutPickupLocationItem-content-infos", {
            "CheckoutPickupLocationItem-content-infos--open": displayOpeningHours,
          })}
        >
          <Link icon={<IconChevron />} iconPosition="right" onClick={handleClick} size="s">
            {intl.formatMessage({
              id: "cheerz_more_infos",
            })}
          </Link>
          <div className="CheckoutPickupLocationItem-content-openingHours">
            <div className="CheckoutPickupLocationItem-content-openingHours-title">
              {intl.formatMessage({ id: "cheerz_CheckoutPickupLocationItem_openingHours_title" })}
            </div>
            {days.map((day) => {
              return (
                <div className="CheckoutPickupLocationItem-content-openingHours-day" key={day}>
                  <div className="CheckoutPickupLocationItem-content-openingHours-day-name">{`${intl
                    .formatMessage({ id: `cheerz_CheckoutPickupLocationItem_day__${day}` })
                    .slice(0, 3)}.`}</div>
                  <div className="CheckoutPickupLocationItem-content-openingHours-day-hours">
                    {location.openingHours[day].length === 0
                      ? intl.formatMessage({
                          id: "cheerz_CheckoutPickupLocationItem_day__closed",
                        })
                      : location.openingHours[day].map((hour) => (
                          <div
                            className="CheckoutPickupLocationItem-content-openingHours-day-hour"
                            key={`${day}${hour.from}${hour.to}`}
                          >
                            <span>{hour.from}</span> - <span>{hour.to}</span>
                          </div>
                        ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <ButtonSmily onClick={() => onSelectLocation(location)} size="xs" type="tertiary">
        {intl.formatMessage({ id: "cheerz_select" })}
      </ButtonSmily>
    </div>
  );
};

export default CheckoutPickupLocationItem;
